<template>
  <div class="row mt-4">
    <div class="title pt-2 required-field col-12">
      <span>{{FORM_LABELS.BOLETO_SLIP_EXPIRY_DATE}}</span>
    </div>
    <div class="mb-4 mt-1 col-12">
      <date-picker-widget
          v-model="currentFormData.boletoSlipExpiryDate"
          class="col-xl-3 col-12 px-0"
          name="boletoSlipExpiryDate"
          v-validate="'required'"
          data-vv-validate-on="input"
          :label="'Select expiry date'"
          :set-min-date="true"
      />
      <show-errors
          :for-item="'boletoSlipExpiryDate'"
          :form-errors="errors"
          :field-name="FORM_LABELS.BOLETO_SLIP_EXPIRY_DATE" />
    </div>
  </div>
</template>

<script>
import DatePickerWidget from "@/components/DatePicker";
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";

export default {
  name: "BoletoPaymentForm",
  props: {
    formData: String
  },
  mixins: [PaymentFormsMixin],
  inject: ['$validator'],
  components: {DatePickerWidget},
  computed: {
    currentFormData() {
      return this.$store.getters[this.formData]
    },
  }
}
</script>

<style scoped>

</style>